import type { PortalRole } from '@product-portal/shared';
import { ROLE_ENTRA_VALUES, ROLE_LABELS } from '@/lib/labels';
import { Pill } from './pill';

const ROLE_CLASSES: Record<PortalRole, string> = {
  requester: 'bg-role-requester text-role-requester-foreground',
  referent: 'bg-role-referent text-role-referent-foreground',
  po: 'bg-role-po text-role-po-foreground',
};

/** Role as carried by the Entra token: displayed, never editable in the portal. */
export function RolePill({ role, showEntraValue = true }: { role: PortalRole; showEntraValue?: boolean }) {
  return (
    <span className="inline-flex flex-col items-start gap-1">
      <Pill className={ROLE_CLASSES[role]}>{ROLE_LABELS[role]}</Pill>
      {showEntraValue && <span className="font-mono text-[11px] text-muted-foreground">{ROLE_ENTRA_VALUES[role]}</span>}
    </span>
  );
}
